var SVGMask = {};

function createSVG( i, img, overlay, color, variant, ie, ff ) {
	// console.log( 'ie: ' + ie );
	// console.log( 'color: ' + color );
	if ( overlay ) {
		if ( variant === 'right' ) {
			var viewbox = '-80 0 880 880',
				x = -80,
				y = 80;
		} else {
			var viewbox = '0 -80 880 880',
				x = 80,
				y = -80;
		}
		if ( ie || ff ) {
			return `<svg class="overlay_ie" x="80px" y="80px" viewBox="${viewbox}">
				<g>
					<polygon points="763.28,218.755 527.344,0 36.72,115.643 36.72,609.381 292.959,800 763.28,693.788" fill="${color}"/>
				</g>
			</svg>
			<svg class="svg_image_ie" x="80px" y="80px" viewBox="${viewbox}">
				<mask id="myMaskOverlay_${i}">
					<rect x="0" y="0" width="100%" height="100%" fill="black" />
					<polygon points="763.28,218.755 527.344,0 36.72,115.643 36.72,609.381 292.959,800 763.28,693.788" fill="white"/>
				</mask>
				<g mask="url(#myMaskOverlay_${i})">
					<image href="${img}" height="100%" width="100%"/>
				</g>
			</svg>`;
		} else {
			return `<svg x="0" y="0" viewBox="${viewbox}">
				<defs>
					<filter id="imageMultiply_${i}">
						<feImage xlink:href="#photo_${i}" x="${x}px" y="${y}px" width="100%" height="100%"/>
						<feBlend in2="SourceGraphic" mode="multiply"/>
					</filter>
					<g id="photo_${i}" mask="url(#myMask_${i})">
						<image href="${img}" height="100%" width="100%"/>
					</g>
					<mask id="myMask_${i}">
						<rect x="0" y="0" width="100%" height="100%" fill="black" />
						<polygon points="763.28,218.755 527.344,0 36.72,115.643 36.72,609.381 292.959,800 763.28,693.788" fill="white"/>
					</mask>
				</defs>
				<polygon points="763.28,218.755 527.344,0 36.72,115.643 36.72,609.381 292.959,800 763.28,693.788" fill="${color}" style="filter:url(#imageMultiply_${i});"/>
			</svg>`;
		}
	} else {
		return `<svg x="0px" y="0px" viewBox="0 0 800 800">
			<mask id="myMaskOverlay">
				<rect x="0" y="0" width="100%" height="100%" fill="black" />
				<polygon points="763.28,218.755 527.344,0 36.72,115.643 36.72,609.381 292.959,800 763.28,693.788" fill="white"/>
			</mask>
			<g mask="url(#myMaskOverlay)">
				<image href="${img}" height="100%" width="100%"/>
			</g>
		</svg>`;
	}
}

function isIEorEdge() {
  if ( /MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent) ) {
    return true;
  }
  return false;
}

function isFF() {
	return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}

SVGMask.init = function() {
	let i = 1;
	$( '.svg-image' ).each( function() {
		var $this = $(this);
		var colorOverlay = ( $this.parents( '.hero').length > 0 ) ? true : false,
			color = ( $this.parents( '.hero').length > 0 ) ? $this.data('color') : false,
			variant = ( $this.parents( '.hero').length > 0 ) ? $this.data('variant') : false,
			ie = isIEorEdge(),
			ff = isFF();
		var svg = createSVG( i, $this.data('src'), colorOverlay, color, variant, ie, ff );
		$this.append( svg ).addClass( 'is-shown' );
		i++;
	} );
}

export { SVGMask };
